module.exports = __webpack_public_path__ + "static/media/judo.f01ccff9.svg";